import React, { useEffect, useState } from 'react';
import './preview.scss';

const PreviewComponent = (props) => {
  let { imageUrl, togglePopUp, uploadedDoc } = props;
  // var binaryData = [];
  // // dummy commit
  // binaryData.push(imageUrl);
  // const file = URL.createObjectURL(new Blob(binaryData));
  console.log(imageUrl, 'url');

  return (
    <div className="modal-body-custom-preview">
      <div className="modal-card">
        <div className="modal-header">
          <h5>&nbsp; </h5>
          <span className="material-icons close" onClick={() => togglePopUp()}>
            close
          </span>
        </div>
        <div className="modal-contents">
          <div className="preview-img">
            <img src={file} alt={imageUrl} title={imageUrl} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewComponent;
